<style lang="stylus">
    .Hotkey-mask
        modal-mask()
        .Hotkey-modal
            width 360px
            .dialog-slot{
              padding: 10px 0;
            }
            .Hotkey-container
                padding 4px 0 20px 34px
                height 480px
                overflow auto
                color var(--text-color-primary)

                // &::-webkit-scrollbar {
                //     height: 8px;
                //     width: 8px;
                //     background-color: #eaeaea;
                //     pointer-events: none;
                // }
                // &::-webkit-scrollbar-thumb:horizontal, &::-webkit-scrollbar-thumb:vertical {
                //     border-radius: 6px;
                //     box-shadow: none;
                //     background-color: #E2E2E7;
                //     pointer-events: none;
                // }

                // &::-webkit-scrollbar-track:vertical, &::-webkit-scrollbar-track:horizontal {
                //     border-radius: 1px;
                //     box-shadow: none;
                //     background-color: #fff;
                //     pointer-events: none;
                // }
                @media screen and (max-height: 768px)
                    overflow unset
                .Hotkey-box
                    position: relative;
                    &::before{
                      display: block;
                      position: absolute;
                      left: 141px;
                      content:'';
                      height: 100%;
                      border-left: 1px dashed var(--border-color-Hotkey-box)
                    }
                    &:not(:last-child)
                        margin-bottom 10px
                    .Hotkey-title
                        position: relative;
                        width 100%
                        text-align left
                        font-size 14px
                        font-weight 700
                        margin-bottom: 11px
                        &::before
                          position: absolute;
                          left: -10px;
                          top: 6px;
                          content: "";
                          display: block;
                          width: 3px;
                          height: 11px;
                          background-color: var(--themeColor);
                          border-radius: 10px;
                    .Hotkey-content
                        width 100%
                        overflow auto
                        list-style none
                        font-size 12px
                        li + li {
                          margin-top: 12px
                        }
                        li
                            display flex
                            justify-content flex-start
                            overflow auto
                            .Hotkey-right
                                margin-left: 17px
                                display flex
                                width 50%
                                div{
                                  position: relative;
                                  height 24px
                                  min-width 20px
                                  padding 5px
                                  text-align center
                                  line-height 12px
                                  border: 1px solid var(--color-black-15);
                                  border-radius: 6px;
                                  margin-right 16px
                                }
                                div + div::before{
                                  display block
                                  position: absolute;
                                  left: -14px
                                  content "+"
                                }
                            .Hotkey-left
                                width 50%
                                line-height 24px
                                font-size 12px
</style>

<template>
    <div class="Hotkey-mask">
        <Dialog class="Hotkey-modal" :title="$t('title')" :isShow="true">
            <div class="Hotkey-container">
                <div class="Hotkey-box" v-for="item in keyData" :key="item.id">
                    <p class="Hotkey-title">{{ $t(item.type) }}</p>
                    <ul class="Hotkey-content">
                        <li v-for="hotkey in item.data" :key="hotkey.id" v-show="!hotkey.show">
                            <div class="Hotkey-left">
                                {{ $t(hotkey.description) }}
                            </div>
                            <div class="Hotkey-right">
                                <div v-for="keys in hotkey.key">
                                    {{ keys }}
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </Dialog>
    </div>
</template>

<script lang="ts">
    import appConfig from "@/public/globalConfig";
    import { Component, Prop, Vue } from "vue-property-decorator";
    import Dialog from "./Dialog.vue";
    declare var eFlagExcelImport: any;

    @Component({
        components: {
            Dialog,
        },
    })
    export default class Hotkey extends Vue {
        tempDisable = !appConfig.isBuild;
        keyData: Array<object> = [
            {
                id: 0,
                type: "file",
                data: [
                    {
                        id: 0,
                        key: ["Ctrl", "O"],
                        description: "openFile",
                    },
                    {
                        id: 1,
                        key: ["Ctrl", "S"],
                        description: "saveFile",
                    },
                    {
                        id: 2,
                        key: ["Ctrl", "Shift", "S"],
                        description: "saveAs",
                    },
                    {
                        id: 3,
                        key: ["Ctrl", "P"],
                        description: "printFile",
                    },
                    {
                        id: 4,
                        key: ["F6"],
                        description: "pageSet",
                    },
                ],
            },
            {
                id: 1,
                type: "edit",
                data: [
                    {
                        id: 0,
                        key: ["F2"],
                        description: "editText",
                    },
                    {
                        id: 1,
                        key: ["Ctrl", "B"],
                        description: "bold",
                    },
                    {
                        id: 2,
                        key: ["Ctrl", "I"],
                        description: "italic",
                    },
                    {
                        id: 3,
                        key: ["Ctrl", "U"],
                        description: "underline",
                    },
                    {
                        id: 4,
                        key: ["Ctrl", "Z"],
                        description: "undo",
                    },
                    {
                        id: 5,
                        key: ["Ctrl", "Y"],
                        description: "redo",
                    },
                    {
                        id: 6,
                        key: ["Ctrl", "X"],
                        description: "cut",
                    },
                    {
                        id: 7,
                        key: ["Ctrl", "C"],
                        description: "copy",
                    },
                    {
                        id: 8,
                        key: ["Ctrl", "V"],
                        description: "paste",
                    },
                    {
                        id: 9,
                        key: ["Ctrl", "D"],
                        description: "quickCopyandPaste",
                    },
                    // {
                    //     id: 10,
                    //     key: ['F7'],
                    //     description: 'checkSpell',
                    // },
                    {
                        id: 11,
                        key: ["Ctrl", "F"],
                        description: "search",
                    },
                    {
                        id: 12,
                        key: ["Ctrl", "Alt", "L"],
                        description: "alignLeft",
                    },
                    {
                        id: 13,
                        key: ["Ctrl", "Alt", "R"],
                        description: "alignRight",
                    },
                    {
                        id: 14,
                        key: ["Ctrl", "Alt", "C"],
                        description: "alignCenter",
                    },
                    {
                        id: 15,
                        key: ["Ctrl", "Shift", ","],
                        description: "decSize",
                    },
                    {
                        id: 16,
                        key: ["Ctrl", "Shift", "."],
                        description: "incSize",
                    },
                ],
            },
            {
                id: 2,
                type: "insert",
                data: [
                    {
                        id: 0,
                        key: ["Ctrl", "Alt", "Z"],
                        description: "note",
                    },
                    {
                        id: 1,
                        key: ["Ctrl", "Alt", "X"],
                        description: "comment",
                    },
                    {
                        id: 2,
                        key: ["Ctrl", "K"],
                        description: "hylink",
                    },
                    {
                        id: 3,
                        key: ["Ctrl", "H"],
                        description: "attach",
                    },
                    {
                        id: 4,
                        key: ["Ctrl", "Alt", "I"],
                        description: "image",
                    },
                    // {
                    //     id: 5,
                    //     key: ['Ctrl', 'Alt', 'S'],
                    //     description: 'svg',
                    // },
                    {
                        id: 6,
                        key: ["Ctrl", "Alt", "T"],
                        description: "table",
                    },
                    {
                        id: 7,
                        key: ["Ctrl", "Alt", "P"],
                        description: "echart",
                    },
                    {
                        id: 8,
                        key: ["Ctrl", "Alt", "M"],
                        description: "map",
                        show: location.host.indexOf("edrawmax.cn"), // 海外没有地图功能
                    },
                    {
                        id: 9,
                        key: ["Ctrl", "Alt", "E"],
                        description: "math",
                    },
                    {
                        id: 10,
                        key: ["Ctrl", "Alt", "Q"],
                        description: "qrcode",
                    },
                ],
            },
            {
                id: 3,
                type: "layout",
                data: [
                    {
                        id: 0,
                        key: ["Ctrl", "A"],
                        description: "selectAll",
                    },
                    {
                        id: 1,
                        key: ["Ctrl", "Shift", "]"],
                        description: "bringFront",
                    },
                    {
                        id: 2,
                        key: ["Ctrl", "Shift", "["],
                        description: "sendBack",
                    },
                    {
                        id: 3,
                        key: ["Ctrl", "]"],
                        description: "bringForward",
                    },
                    {
                        id: 4,
                        key: ["Ctrl", "["],
                        description: "sendBackward",
                    },
                    {
                        id: 5,
                        key: ["Ctrl", "Shift", "Y"],
                        description: "unlock",
                    },
                    {
                        id: 6,
                        key: ["Ctrl", "G"],
                        description: "compose",
                    },
                    {
                        id: 7,
                        key: ["Ctrl", "Shift", "G"],
                        description: "uncompose",
                    },
                    {
                        id: 8,
                        key: ["Alt", "L"],
                        description: "shapeLeft",
                    },
                    {
                        id: 9,
                        key: ["Alt", "R"],
                        description: "shapeRight",
                    },
                    {
                        id: 10,
                        key: ["Alt", "C"],
                        description: "shapeCenter",
                    },
                ],
            },
            {
                id: 4,
                type: "view",
                data: [
                    {
                        id: 0,
                        key: ["Ctrl", "+"],
                        description: "bigger",
                    },
                    {
                        id: 1,
                        key: ["Ctrl", "-"],
                        description: "smaller",
                    },
                    {
                        id: 2,
                        key: ["F9"],
                        description: "showDataSheet",
                    },
                    {
                        id: 3,
                        key: ["Shift", "F11"],
                        description: "addPage",
                    },
                ],
            },
            {
                id: 5,
                type: "linkline",
                data: [
                    {
                        id: 0,
                        key: ["Ctrl", "3"],
                        description: "linkline1",
                    },
                    {
                        id: 1,
                        key: ["Ctrl", "4"],
                        description: "linkline2",
                    },
                    {
                        id: 2,
                        key: ["Ctrl", "5"],
                        description: "linkline3",
                    },
                ],
            },
            {
                id: 666,
                type: "others",
                data: [
                    {
                        id: 0,
                        key: ["Backspace"],
                        description: "backspace",
                    },
                    {
                        id: 1,
                        key: ["Ctrl", "2"],
                        description: "textEdit",
                    },
                    {
                        id: 2,
                        key: ["Shift", "Enter"],
                        description: "otherLine",
                    },
                    {
                        id: 3,
                        key: ["Shift", "L"],
                        description: "library",
                    },
                    {
                        id: 4,
                        key: ["Ctrl", "Shift", "F"],
                        description: "searchFunc",
                    },
                ],
            },
        ];
        mounted() {
            if (!this.tempDisable) {
                (<any>this.keyData[0]).data.shift();
            }
            if (this.isPlugin) {
                this.keyData.shift();
            }
        }

        created() {}
    }
</script>
<i18n>
{
  "zh": {
    "title": "快捷键",
    "file": "文件菜单",
    "openFile": "打开文件",
    "saveFile": "保存文件",
    "saveAs": "另存为",
    "printFile": "打印文件",
    "pageSet": "页面设置",
    "edit": "编辑菜单",
    "undo": "撤销",
    "redo": "重做",
    "cut": "剪切",
    "copy": "复制",
    "paste": "粘贴",
    "checkSpell": "拼写检查",
    "search": "查找和替换",
    "insert": "插入菜单",
    "note": "注释",
    "comment": "评论",
    "hylink": "超链接",
    "attach": "附件",
    "image": "图片",
    "svg": "SVG",
    "table": "表格",
    "echart": "图表",
    "map": "地图",
    "math": "数学公式",
    "qrcode": "二维码",
    "layout": "布局菜单",
    "bringFront": "移至顶层",
    "sendBack": "移至底层",
    "bringForward": "前移一层",
    "sendBackward": "后移一层",
    "unlock": "解锁",
    "compose": "组合",
    "uncompose": "取消组合",
    "view": "视图菜单",
    "bigger": "放大",
    "smaller": "缩小",
    "showDataSheet": "显示数据表",
    "linkline": "连接线",
    "linkline1": "直角连接线",
    "linkline2": "曲线连接线",
    "linkline3": "直线连接线",
    "others": "其他",
    "backspace": "删除",
    "textEdit": "文本工具",
    "otherLine": "换行",
    "quickCopyandPaste": "快速复制和粘贴",
    "library": "显示符号库",
    "alignLeft": "文本居中左对齐",
    "alignRight": "文本居中右对齐",
    "alignCenter": "文本居中对齐",
    "shapeLeft": "形状左对齐",
    "shapeRight": "形状右对齐",
    "shapeCenter": "形状水平居中",
    "addPage": "添加页面",
    "selectAll": "全选",
    "editText": "编辑文本",
    "bold": "加粗",
    "italic": "斜体",
    "underline": "下划线",
    "incSize": "字体增大",
    "decSize": "字体减小",
    "searchFunc": "功能查找"
  },
  "en": {
    "title": "Hotkey Reference",
    "file": "File",
    "openFile": "Open File",
    "saveFile": "Save File",
    "saveAs": "Save As",
    "printFile": "Print File",
    "pageSet": "Page Setup",
    "edit": "Edit",
    "undo": "Undo",
    "redo": "Redo",
    "cut": "Cut",
    "copy": "Copy",
    "paste": "Paste",
    "checkSpell": "Check Spelling",
    "search": "Find and Replace",
    "insert": "Insert",
    "note": "Note",
    "comment": "Comment",
    "hylink": "Hyperlink",
    "attach": "Attachment",
    "image": "Image",
    "svg": "SVG",
    "table": "Table",
    "echart": "Chart",
    "map": "Map",
    "math": "Math Formula",
    "qrcode": "QR Code",
    "layout": "Layout",
    "bringFront": "Bring to Front",
    "sendBack": "Send to Back",
    "bringForward": "Bring Forward",
    "sendBackward": "Send Backward",
    "unlock": "Unlock",
    "compose": "Group",
    "uncompose": "Ungroup",
    "view": "View",
    "bigger": "Zoom in",
    "smaller": "Zoom out",
    "showDataSheet": "Show Data Sheet",
    "linkline": "Connector",
    "linkline1": "Elbow Connector",
    "linkline2": "Curved Connector",
    "linkline3": "Straight Connector",
    "others": "Others",
    "backspace": "Delete",
    "textEdit": "Text Tool",
    "otherLine": "Line feed",
    "quickCopyandPaste": "Quick copy and paste",
    "library": "Show Library",
    "alignLeft": "Text left",
    "alignRight": "Text right",
    "alignCenter": "Text center",
    "shapeLeft": "Shape left",
    "shapeRight": "Shape right",
    "shapeCenter": "Shape horizontal center",
    "addPage": "Add page",
    "selectAll": "Select All",
    "editText": "Edit Text",
    "bold": "Bold",
    "italic": "Italic",
    "underline": "Underline",
    "incSize": "Font increase",
    "decSize": "Font reduction",
    "searchFunc": "Feature Find"
  },
  "jp": {
    "title": "ショートカット",
    "file": "ファイルメニュー",
    "openFile": "ファイルを開く",
    "saveFile": "ファイルを保存",
    "saveAs": "名前をつけて保存",
    "printFile": "ファイルを印刷",
    "pageSet": "ページ設定",
    "edit": "メニューを編集",
    "undo": "取り消し",
    "redo": "やり直し",
    "cut": "カット",
    "copy": "コピー",
    "paste": "貼り付け",
    "checkSpell": "スペルチェック",
    "search": "検索と置換",
    "insert": "メニューを挿入",
    "note": "注釈",
    "comment": "コメント",
    "hylink": "ハイパーリンク",
    "attach": "アタッチメント",
    "image": "画像",
    "svg": "SVG",
    "table": "表",
    "echart": "チャート",
    "map": "地図",
    "math": "数学公式",
    "qrcode": "QRコード",
    "layout": "メニューを設定",
    "bringFront": "最前面へ移動",
    "sendBack": "再背面へ移動",
    "bringForward": "前面へ移動",
    "sendBackward": "背面へ移動",
    "unlock": "ロック解除",
    "compose": "グループ化",
    "uncompose": "グループ化解除",
    "view": "表示メニュー",
    "bigger": "ズームイン",
    "smaller": "ズームアウト",
    "showDataSheet": "データシートを表示",
    "linkline": "接続線",
    "linkline1": "直角接続線",
    "linkline2": "曲線接続線",
    "linkline3": "直線接続線",
    "others": "その他",
    "backspace": "削除",
    "textEdit": "テキストツール",
    "otherLine": "改行",
    "quickCopyandPaste": "クイックコピーとペースト",
    "library": "ライブラリを表示",
    "alignLeft": "テキスト左",
    "alignRight": "テキスト右",
    "alignCenter": "テキストセンター",
    "shapeLeft": "形状左",
    "shapeRight": "形状右",
    "shapeCenter": "形状水平中心",
    "addPage": "ページ追加",
    "selectAll": "すべて選択",
    "editText": "テキストを編集",
    "bold": "太字",
    "italic": "斜体",
    "underline": "下線",
    "incSize": "フォントの増加",
    "decSize": "フォントの削減",
    "searchFunc": "機能検索"
  },
  "fr": {
    "title": "Raccourci",
    "file": "Menu Fichier",
    "openFile": "Ouvrir Fichier",
    "saveFile": "Enregistrer Fichier",
    "saveAs": "Sauvegarder comme",
    "printFile": "Imprimer Fichier",
    "pageSet": "Mise en page",
    "edit": "Éditer Menu",
    "undo": "Annuler",
    "redo": "Refaire",
    "cut": "Couper",
    "copy": "Copier",
    "paste": "Coller",
    "checkSpell": "Vérification Orthographique",
    "search": "Trouver et Remplacer",
    "insert": "Insérer Menu",
    "note": "Note",
    "comment": "Commentaire",
    "hylink": "Hyperlien",
    "attach": "Attachement",
    "image": "Image",
    "svg": "SVG",
    "table": "Table",
    "echart": "Graphique",
    "map": "Carte",
    "math": "Formule Mathématique",
    "qrcode": "Code QR",
    "layout": "Menu Disposition",
    "bringFront": "Déplacer vers le haut",
    "sendBack": "Déplacer vers le bas",
    "bringForward": "Avancer",
    "sendBackward": "Reculer",
    "unlock": "Déverrouiller",
    "compose": "Groupe",
    "uncompose": "Dissocier",
    "view": "Menu Affichage",
    "bigger": "Zoom Avant",
    "smaller": "Zoom Arrière",
    "showDataSheet": "Afficher le Tableau de Données",
    "linkline": "Ligne de Connexion",
    "linkline1": "Connecteur Coudé",
    "linkline2": "Connecteur Incurvé",
    "linkline3": "Connecteur Droit",
    "others": "Autres",
    "backspace": "Supprimer",
    "textEdit": "Outil Texte",
    "otherLine": "Emballage",
    "quickCopyandPaste": "Copier-coller rapide",
    "library": "Afficher la Bibliothèque de Symboles",
    "alignLeft": "Texte à gauche",
    "alignRight": "Permissions de texte",
    "alignCenter": "Centre de texte",
    "shapeLeft": "Type gauche",
    "shapeRight": "Forme correcte",
    "shapeCenter": "Centre horizontal de la forme",
    "addPage": "Ajouter une page",
    "selectAll": "Sélectionner tous",
    "editText": "Modifier le texte",
    "bold": "Audacieux",
    "italic": "Italique",
    "underline": "Souligner",
    "incSize": "Augmentation de la police",
    "decSize": "Réduction de la police",
    "searchFunc": "Recherche de fonction"
  },
  "de": {
    "title": "Hotkey",
    "file": "Datei",
    "openFile": "Datei öffnen",
    "saveFile": "Datei speichern",
    "saveAs": "Speichern als",
    "printFile": "Datei drucken",
    "pageSet": "Seite einstellen",
    "edit": "Bearbeiten",
    "undo": "Rückgängig machen",
    "redo": "Wiederherstellen",
    "cut": "Schneiden",
    "copy": "Kopieren",
    "paste": "Einfügen",
    "checkSpell": "Schreibweise überprüfen",
    "search": "Suchen und Ersetzen",
    "insert": "Einfügen",
    "note": "Hinweis",
    "comment": "Kommentar",
    "hylink": "Hyperlink",
    "attach": "Anhang",
    "image": "Bild",
    "svg": "SVG",
    "table": "Tabelle",
    "echart": "Diagramm",
    "map": "Karte",
    "math": "Mathematische Formel",
    "qrcode": "QR Code",
    "layout": "Layout",
    "bringFront": "Nach vorne bringen",
    "sendBack": "Nach hinten senden",
    "bringForward": "Vorwärts bringen",
    "sendBackward": "Rückwärts senden",
    "unlock": "Freischalten",
    "compose": "Gruppieren",
    "uncompose": "Gruppe auflösen",
    "view": "Ansicht",
    "bigger": "Vergrößern",
    "smaller": "Verkleinern",
    "showDataSheet": "Datenblatt anzeigen",
    "linkline": "Verbinder",
    "linkline1": "Ellenbogen-Verbinder",
    "linkline2": "Kurven-Verbinder",
    "linkline3": "Gerader-Verbinder",
    "others": "Andere",
    "backspace": "Löschen",
    "textEdit": "Text Tool",
    "otherLine": "Linien wechseln ",
    "quickCopyandPaste": "Schnell kopieren und einfügen",
    "library": "Bibliothek anzeigen",
    "alignLeft": "Text links",
    "alignRight": "Text rechts",
    "alignCenter": "Text Mitte",
    "shapeLeft": "Form links",
    "shapeRight": "Form rechts",
    "shapeCenter": "Horizontale Mitte formen",
    "addPage": "Seite hinzufügen",
    "selectAll": "Alle auswählen",
    "editText": "Text bearbeiten",
    "bold": "Fett",
    "italic": "Kursiv",
    "underline": "Unterstreichen",
    "incSize": "Schrift vergrößern",
    "decSize": "Schriftreduzierung",
    "searchFunc": "Suchen"
  },
  "es": {
    "title": "Referencia de Hotkey",
    "file": "Archivo",
    "openFile": "Archivo abierto",
    "saveFile": "Guardar archivo ",
    "saveAs": "Guardar como",
    "printFile": "Archivo de impresión",
    "pageSet": "Configurar página",
    "edit": "Editar",
    "undo": "Deshacer",
    "redo": "Rehacer",
    "cut": "Cortar",
    "copy": "Copia",
    "paste": "Pegar",
    "checkSpell": "Revisar ortografía",
    "search": "Encontrar y reemplazar",
    "insert": "Insertar",
    "note": "Nota",
    "comment": "Comentario",
    "hylink": "Hipervínculo",
    "attach": "Adjunto",
    "image": "Imagen",
    "svg": "SVG",
    "table": "Mesa",
    "echart": "Gráfico",
    "map": "Mapa",
    "math": "Fórmula matemática",
    "qrcode": "Código QR",
    "layout": "Diseño",
    "bringFront": "Traer al Frente",
    "sendBack": "Traer al atrás",
    "bringForward": "Adelantar",
    "sendBackward": "Enviar atrás",
    "unlock": "Desbloquear",
    "compose": "Grupo",
    "uncompose": "Desagrupar",
    "view": "Ver",
    "bigger": "Ampliar",
    "smaller": "Alejar",
    "showDataSheet": "Mostrar Hoja de Datos",
    "linkline": "Conector",
    "linkline1": "Conector del codo",
    "linkline2": "Conector curvo",
    "linkline3": "Conector recto",
    "others": "Otros",
    "backspace": "Borrar",
    "textEdit": "Herramienta de texto",
    "otherLine": "Linea de alimentación",
    "quickCopyandPaste": "Copiar y pegar rápidamente",
    "library": "Mostrar la biblioteca",
    "alignLeft": "Wenben Zuo",
    "alignRight": "Permisos de texto",
    "alignCenter": "Centro de texto",
    "shapeLeft": "Tipo izquierdo",
    "shapeRight": "Forma correcta",
    "shapeCenter": "Centro horizontal de la forma",
    "addPage": "Añadir página",
    "selectAll": "Seleccionar Todo",
    "editText": "Editar el texto",
    "bold": "Negrito",
    "italic": "Cursiva",
    "underline": "Subraye",
    "incSize": "Aumento de fuente",
    "decSize": "Reducción de fuentes",
    "searchFunc": "Búsqueda de características"
  },
  "pt": {
    "title": "Referência de Tecla de Atalho",
    "file": "Ficheiro",
    "openFile": "Abrir Ficheiro",
    "saveFile": "Gravar Ficheiro",
    "saveAs": "Gravar Como",
    "printFile": "Imprimir Ficheiro",
    "pageSet": "Configuração de Página",
    "edit": "Editar",
    "undo": "Desfazer",
    "redo": "Refazer",
    "cut": "Cortar",
    "copy": "Copiar",
    "paste": "Colar",
    "checkSpell": "Verificação Ortográfica",
    "search": "Encontrar e Substituir",
    "insert": "Inserir",
    "note": "Nota",
    "comment": "Comentário",
    "hylink": "Hiperligação",
    "attach": "Anexo",
    "image": "Imagem",
    "svg": "SVG",
    "table": "Tabela",
    "echart": "Gráfico",
    "map": "Mapa",
    "math": "Fórmula Matemática",
    "qrcode": "Código QR",
    "layout": "Layout",
    "bringFront": "Trazer para a Frente",
    "sendBack": "Enviar para Trás",
    "bringForward": "Avançar",
    "sendBackward": "Retroceder",
    "unlock": "Desbloquear",
    "compose": "Agrupar",
    "uncompose": "Desagrupar",
    "view": "Visualização",
    "bigger": "Aumentar Zoom",
    "smaller": "Diminuir Zoom",
    "showDataSheet": "Mostrar Folha de Dados",
    "linkline": "Conector",
    "linkline1": "Conector de Cotovelo",
    "linkline2": "Conector Curvo",
    "linkline3": "Conector Reto",
    "others": "Outros",
    "backspace": "Eliminar",
    "textEdit": "Ferramenta de Texto",
    "otherLine": "Avanço de Linha",
    "quickCopyandPaste": "Copiar e colar rápido",
    "library": "Mostrar Biblioteca",
    "alignLeft": "Texto à esquerda",
    "alignRight": "Texto à direita",
    "alignCenter": "Centro de texto",
    "shapeLeft": "Forma à esquerda",
    "shapeRight": "Forma à direita",
    "shapeCenter": "Forma centro horizontal",
    "addPage": "Adicionar página",
    "selectAll": "Selecionar Tudo",
    "editText": "Editar Texto",
    "bold": "Negrito",
    "italic": "Itálico",
    "underline": "Sublinhar",
    "incSize": "Aumento de fonte",
    "decSize": "Redução de fonte",
    "searchFunc": "Encontrar Característica"
  },
  "it": {
    "title": "Riferimento Scorciatoie",
    "file": "File",
    "openFile": "Apri File",
    "saveFile": "Salva File",
    "saveAs": "Salva come",
    "printFile": "Stampa File",
    "pageSet": "Impostazione pagina",
    "edit": "Modifica",
    "undo": "Annulla",
    "redo": "Ripeti",
    "cut": "Taglia",
    "copy": "Copia",
    "paste": "Incolla",
    "checkSpell": "Controllo Ortografico",
    "search": "Trova e Sostituisci",
    "insert": "Inserisci",
    "note": "Nota",
    "comment": "Commento",
    "hylink": "Collegamento",
    "attach": "Attaccamento",
    "image": "Immagine",
    "svg": "SVG",
    "table": "Tabella",
    "echart": "Diagramma",
    "map": "Mappa",
    "math": "Formula Matematica",
    "qrcode": "Codice QR",
    "layout": "Layout",
    "bringFront": "Porta in Primo Piano",
    "sendBack": "Porta in Secondo Piano",
    "bringForward": "Porta Avanti",
    "sendBackward": "Porta Indietro",
    "unlock": "Sblocca",
    "compose": "Raggruppa",
    "uncompose": "Separa",
    "view": "Vista",
    "bigger": "Zoom Avanti",
    "smaller": "Zoom Indietro",
    "showDataSheet": "Mostra Scheda Dati",
    "linkline": "Connettore",
    "linkline1": "Connettore ad Angolo",
    "linkline2": "Connettore Curvo",
    "linkline3": "Connettore Dritto",
    "others": "Altri",
    "backspace": "Elimina",
    "textEdit": "Strumento Testo",
    "otherLine": "Avanzamento Riga",
    "quickCopyandPaste": "Copia e incolla veloce",
    "library": "Mostra Libreria",
    "alignLeft": "Testo a sinistra",
    "alignRight": "Testo a destra",
    "alignCenter": "Centro di testo",
    "shapeLeft": "Forma a sinistra",
    "shapeRight": "Forma a destra",
    "shapeCenter": "Forma centro orizzontale",
    "addPage": "Aggiungi pagina",
    "selectAll": "Seleziona Tutto",
    "editText": "Modifica Testo",
    "bold": "Grassetto",
    "italic": "Italico",
    "underline": "Sottolineato",
    "incSize": "Aumento del carattere",
    "decSize": "Riduzione del carattere",
    "searchFunc": "Trova Funzioni"
  },
  "tw": {
    "title": "快速鍵",
    "file": "檔案菜單",
    "openFile": "打開檔案",
    "saveFile": "儲存檔案",
    "saveAs": "另存新檔",
    "printFile": "列印檔案",
    "pageSet": "頁面設置",
    "edit": "編輯菜單",
    "undo": "復原",
    "redo": "取消復原",
    "cut": "剪下",
    "copy": "複製",
    "paste": "貼上",
    "checkSpell": "拼寫檢查",
    "search": "查找和替換",
    "insert": "插入菜單",
    "note": "注釋",
    "comment": "評論",
    "hylink": "超連結",
    "attach": "附件",
    "image": "圖片",
    "svg": "SVG",
    "table": "表格",
    "echart": "圖表",
    "map": "地圖",
    "math": "數學公式",
    "qrcode": "二維碼",
    "layout": "佈局菜單",
    "bringFront": "移至頂層",
    "sendBack": "移至底層",
    "bringForward": "前移一層",
    "sendBackward": "後移一層",
    "unlock": "解鎖",
    "compose": "組合",
    "uncompose": "取消組合",
    "view": "視圖菜單",
    "bigger": "放大",
    "smaller": "縮小",
    "showDataSheet": "顯示數據表",
    "linkline": "連接線",
    "linkline1": "直角連接線",
    "linkline2": "曲線連接線",
    "linkline3": "直線連接線",
    "others": "其他",
    "backspace": "刪除",
    "textEdit": "文本工具",
    "otherLine": "換行",
    "quickCopyandPaste": "快速復制和貼上",
    "library": "顯示符號庫",
    "alignLeft": "文字居中左對齊",
    "alignRight": "文字居中右對齊",
    "alignCenter": "文字居中對齊",
    "shapeLeft": "形狀左對齊",
    "shapeRight": "形狀右對齊",
    "shapeCenter": "形狀水准居中",
    "addPage": "添加頁面",
    "selectAll": "選擇全部",
    "editText": "編輯文本",
    "bold": "加粗",
    "italic": "斜體",
    "underline": "下劃線",
    "incSize": "字體增大",
    "decSize": "字體減小",
    "searchFunc": "功能查找"
  },
  "kr": {
    "title": "단축키",
    "file": "파일 메뉴",
    "openFile": "파일 열기",
    "saveFile": "파일 저장",
    "saveAs": "다른 이름으로 저장",
    "printFile": "파일 인쇄",
    "pageSet": "페이지 설정",
    "edit": "메뉴 편집",
    "undo": "취소",
    "redo": "다시 만들기 ",
    "cut": "자르기 ",
    "copy": "복사",
    "paste": "붙여넣기",
    "checkSpell": "맞춤법 검사",
    "search": "검색하고 바꾸기",
    "insert": "메뉴 삽입",
    "note": "주석",
    "comment": "댓글",
    "hylink": "하이퍼링크",
    "attach": "부속품",
    "image": "이미지",
    "svg": "SVG",
    "table": "표",
    "echart": "도표",
    "map": "지도",
    "math": "수학 공식",
    "qrcode": "QR코드",
    "layout": "레이아웃",
    "bringFront": "맨 위층으로 이동",
    "sendBack": "밑바닥으로 이동",
    "bringForward": "한 층 앞으로 이동",
    "sendBackward": "한 층 뒤로 이동",
    "unlock": "잠금 해제",
    "compose": "조합",
    "uncompose": "조합 취소",
    "view": "보기 메뉴",
    "bigger": "확대",
    "smaller": "축소",
    "showDataSheet": "데이터시트 보이기",
    "linkline": "커넥터",
    "linkline1": "엘보 커넥터",
    "linkline2": "곡선 커넥터",
    "linkline3": "직선 커넥터",
    "others": "기타 ",
    "backspace": "삭제 ",
    "textEdit": "텍스트 도구",
    "otherLine": "줄을 바꾸기",
    "quickCopyandPaste": "빠른 복사 및 붙여넣기",
    "library": "라이브러리 표시",
    "alignLeft": "문본좌",
    "alignRight": "텍스트 사용 권한",
    "alignCenter": "텍스트 센터",
    "shapeLeft": "좌형",
    "shapeRight": "모양이 정확하다",
    "shapeCenter": "모양 수평 중심",
    "addPage": "페이지 추가",
    "selectAll": "전체 선택",
    "editText": "텍스트 편집",
    "bold": "굵기",
    "italic": "기울기",
    "underline": "밑줄",
    "incSize": "글꼴 증가",
    "decSize": "글꼴 축소",
    "searchFunc": "기능 찾기"
  }
}
</i18n>
